const translations = {
  "en": {
    "Add": "Add",
    "Are you sure you want to unlink this wallet now?": "Are you sure you want to unlink this wallet now?",
    "Chill a bit. We're making your wallet happier": "Chill a bit. We're making your wallet happier",
    "Connect": "Connect",
    "Continue in the wallet…": "Continue in the wallet…",
    "Link Your Wallet": "Link Your Wallet",
    "Tell Edgen where to send your future rewards. Aura farmers gotta get paid.": "Connect your wallet, it will be where future rewards will go!",
    "Unlink wallet": "Unlink wallet"
  },
  "zh-tw": {
    "Add": "新增",
    "Are you sure you want to unlink this wallet now?": "你確定要立即取消連結這個錢包嗎？",
    "Chill a bit. We're making your wallet happier": "放輕鬆點，我們正在讓你的錢包更開心",
    "Connect": "連接",
    "Continue in the wallet…": "繼續在錢包中…",
    "Link Your Wallet": "連結你的錢包",
    "Tell Edgen where to send your future rewards. Aura farmers gotta get paid.": "連結你的錢包，之後的獎勵都會發到這裡！",
    "Unlink wallet": "解除錢包連結"
  }
};

export default translations;
